import Image from 'app/Components/Shared/Image/image';
import "./BeforeContinuePopUp.scss"
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {dwhPortingEsimPopupDisplayed, dwhPortingInfoPopupDisplayed} from '../reports/dwhReports';

const BeforeContinuePopUp = (props) => {
  let popUpTitleBeforeContinueNiudEsim = null;
  let instructionBeforeContinueNiudEsim = null;

  if (props.iContent.esimData?.value != null) {
    instructionBeforeContinueNiudEsim = props.iContent.esimData?.expandedValue[0]?.instructionBeforeContinueNiudEsim?.value;
    popUpTitleBeforeContinueNiudEsim = props.iContent?.esimData?.expandedValue[0]?.popUpTitleBeforeContinueNiudEsim?.value;
  }

  let popUpTitleBeforeContinueNiudSim = props.iContent?.popUpTitleBeforeContinueNiudSim?.value;
  let instructionBeforeContinueNiudSim = props.iContent?.instructionBeforeContinueNiudSim?.value;

  useEffect(() => {
    if (props.isEsim != null && props.isEsim === true) {
      dwhPortingEsimPopupDisplayed({
        subscriber: props.subscriber ?? '',
        param1: 'eSim',
        userDetails: props.userDetails,
      });
    } else {
      dwhPortingInfoPopupDisplayed({
        subscriber: props.subscriber ?? '',
        param1: 'SIM',
        userDetails: props.userDetails,
      });
    }
  }, []);

  return (
    <>
      {props.isPopUp ? (
        <>
          <div className='beforeContinuePopUpContainer'>
            <div className='img-container'>
              <Image src={require('../images/icon-100-insight.svg')} alt='light-icon' />
            </div>
            <h4 className='title'>{props.isEsim ? popUpTitleBeforeContinueNiudEsim : popUpTitleBeforeContinueNiudSim}</h4>
            <div className='instructionList'>
              {props.isEsim ? (
                <>
                  {instructionBeforeContinueNiudEsim != null &&
                    instructionBeforeContinueNiudEsim?.map((e, i) => {
                      return (
                        <>
                          <li key={i}>{e}</li>
                        </>
                      );
                    })}
                </>
              ) : (
                <>
                  {instructionBeforeContinueNiudSim &&
                    instructionBeforeContinueNiudSim?.map((e, i) => {
                      return (
                        <>
                          <li key={i}>{e}</li>
                        </>
                      );
                    })}
                </>
              )}
            </div>
          </div>
          <div className='footer-pop-up-container'>
            {props.footerButton != null ? <div className='footerButton'>{props.footerButton}</div> : <></>}
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  userDetails: state.authentication?.loginData?.userDetails,
});

export default connect(mapStateToProps)(BeforeContinuePopUp);
